import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Disc3 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const heroImg = "https://images.unsplash.com/photo-1499415479124-43c32433a620?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  const inputCls = "w-full bg-zinc-900/60 border border-white/10 text-white placeholder-zinc-500 px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-[#FFD60A] focus:border-[#FFD60A]";

  return (
    <div className="min-h-[calc(100vh-6.5rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={heroImg} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/30" />
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="font-display text-4xl font-black tracking-tighter text-white">Where the next sound breaks first.</h2>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-8">
            <Disc3 className="h-7 w-7 text-[#FFD60A]" />
            <span className="font-brand text-2xl text-[#FFD60A]">NEXTtt<sup className="text-[0.5em] align-super ml-0.5">™</sup></span>
          </div>
          <h1 className="font-display text-3xl font-bold text-white">Welcome back</h1>
          <p className="text-zinc-400 mt-1 mb-8">Log in to keep watching and creating.</p>

          {error && <div data-testid="login-error" className="mb-4 bg-[#FFD60A]/10 border border-[#FFD60A]/40 text-[#FFD60A] text-sm px-4 py-3">{error}</div>}

          <form onSubmit={submit} className="space-y-4">
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={inputCls} required />
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputCls} required />
            <button type="submit" disabled={busy} data-testid="login-submit" className="w-full bg-[#FFD60A] text-black py-3 font-semibold hover:bg-[#FFD60A]/90 transition-colors disabled:opacity-60">
              {busy ? "Logging in…" : "Log in"}
            </button>
          </form>

          <p className="text-sm text-zinc-400 mt-6">New here? <Link to="/register" className="text-[#FFD60A] font-semibold hover:underline">Create an account</Link></p>
          <p className="text-sm text-zinc-500 mt-2"><Link to="/owner" data-testid="owner-login-link" className="hover:text-[#FFD60A]">Owner sign-in with email code →</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
